// extracted by mini-css-extract-plugin
export var carouselContainer = "z_qt d_s d_D d_bb d_W";
export var carouselContainerCards = "z_s5 z_qt d_s d_D d_bb d_W";
export var carouselContainerSides = "z_s6 d_s d_D d_W";
export var prevCarouselItem = "z_s7 d_s d_D d_X d_g";
export var prevCarouselItemL = "z_s8 z_s7 d_s d_D d_X d_g";
export var moveInFromLeft = "z_s9";
export var prevCarouselItemR = "z_tb z_s7 d_s d_D d_X d_g";
export var moveInFromRight = "z_tc";
export var selectedCarouselItem = "z_td d_s d_D d_W d_bb";
export var selectedCarouselItemL = "z_tf z_td d_s d_D d_W d_bb";
export var selectedCarouselItemR = "z_tg z_td d_s d_D d_W d_bb";
export var nextCarouselItem = "z_th d_s d_D d_X d_g";
export var nextCarouselItemL = "z_tj z_th d_s d_D d_X d_g";
export var nextCarouselItemR = "z_tk z_th d_s d_D d_X d_g";
export var arrowContainer = "z_tl d_D d_X d_dx d_bh d_1 d_bY";
export var prevArrowContainer = "z_tm z_tl d_D d_X d_dx d_bh d_1 d_bY";
export var prevArrowContainerHidden = "z_tn z_tm z_tl d_D d_X d_dx d_bh d_1 d_bY d_g";
export var nextArrowContainer = "z_tp z_tl d_D d_X d_dx d_bh d_1 d_bY";
export var carouselContainerProducts = "z_tq";
export var nextArrowContainerHidden = "z_tr z_tp z_tl d_D d_X d_dx d_bh d_1 d_bY d_g";
export var arrow = "z_kK d_X";
export var prevArrow = "z_ts z_kK d_X";
export var nextArrow = "z_tt z_kK d_X";
export var carouselIndicatorContainer = "z_tv d_s d_ds d_bh d_bw d_bz d_bL d_bF d_X";
export var btnsContainer = "z_tw d_s d_bw d_bB";
export var carouselText = "z_tx d_dm d_bw d_bz d_bL d_bY d_dx d_cz";
export var carouselTextInactive = "z_ty z_tx d_dm d_bw d_bz d_bL d_bY d_dx d_cz";
export var indicator = "z_tz d_b4";
export var carouselIndicator = "z_tB z_tz d_b4";
export var carouselIndicatorSelected = "z_tC z_tz d_b4";
export var arrowsContainerTopRight = "z_tD d_X d_bh d_by";
export var arrowsContainerBottomLeft = "z_tF d_X d_bh d_by";
export var arrowsContainerSides = "z_tG d_X d_bh d_by";
export var smallArrowsBase = "z_tH d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainer = "z_tJ z_tH d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainerPrev = "z_tK z_tJ z_tH d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainerSmall = "z_tL z_tH d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var smallArrowContainerPrevSmall = "z_tM z_tL z_tH d_bQ d_bw d_bz d_bL d_bY d_dx d_cz";
export var icon = "z_p0";
export var iconSmall = "z_tN";
export var multipleWrapper = "z_tP d_by d_bB d_bb";
export var multipleImage = "z_tQ d_by";
export var sidesPrevContainer = "z_tR z_tJ z_tH d_bQ d_bw d_bz d_bL d_bY d_dx d_cz d_fk d_X d_bh d_cz";
export var sidesNextContainer = "z_tS z_tJ z_tH d_bQ d_bw d_bz d_bL d_bY d_dx d_cz d_fk d_X d_bh d_cz";